import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterC = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M12.392 16.712C9.836 16.712 8 14.792 8 12.356C8 9.92 9.836 8 12.392 8C13.928 8 15.296 8.78 16.004 10.004L14.804 10.7C14.36 9.872 13.448 9.344 12.392 9.344C10.58 9.344 9.38 10.628 9.38 12.356C9.38 14.084 10.58 15.368 12.392 15.368C13.448 15.368 14.372 14.84 14.804 14.012L16.004 14.696C15.308 15.92 13.94 16.712 12.392 16.712Z" }),
});

export { IconCapitalLetterC };
